// src/pages/CheckoutPage.jsx
import { useCart } from "../CartContext";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE from "../api";

export default function CheckoutPage({ lang }) {
  const { cart, clearCart } = useCart();
  const navigate = useNavigate();

  const total = cart.reduce(
    (sum, p) => sum + Number(p.price || 0) * (p.qty || 1),
    0
  );

  const [form, setForm] = useState({
    name: "",
    email: "",
    address: "",
    country: "PL",
    payment: "P24",
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Podaj imię i nazwisko";
    if (!form.email.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/))
      e.email = "Podaj poprawny adres email";
    if (form.address.trim().length < 5)
      e.address = "Adres jest zbyt krótki";
    if (!form.country) e.country = "Wybierz kraj";
    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const foundErrors = validate();
    setErrors(foundErrors);
    if (Object.keys(foundErrors).length > 0) return;

    try {
      const res = await axios.post(`${API_BASE}/api/create-order`, {
        customer: form,
        cart,
        total,
      });

      if (form.payment === "BANK") {
        clearCart();
        navigate("/bank-transfer");
        return;
      }

      if (res.data?.redirectUrl) {
        window.location.href = res.data.redirectUrl;
        return;
      }

      alert("Błąd płatności.");
    } catch (err) {
      console.error("PAYMENT ERROR", err);
      alert("Błąd przy tworzeniu zamówienia.");
    }
  };

  return (
    <section className="section" style={{ maxWidth: "600px", margin: "0 auto" }}>
      <h2>{lang === "pl" ? "Zamówienie" : "Checkout"}</h2>

      <form className="checkout-form premium" onSubmit={handleSubmit}>
        {/* DANE */}
        <div className="checkout-section-title">
          {lang === "pl" ? "Dane osobowe" : "Customer details"}
        </div>

        <label>Imię i nazwisko</label>
        <input
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        {errors.name && <div className="error">{errors.name}</div>}

        <label>Email</label>
        <input
          type="email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
        {errors.email && <div className="error">{errors.email}</div>}

        {/* ADRES */}
        <div className="checkout-section-title" style={{ marginTop: "10px" }}>
          {lang === "pl" ? "Adres dostawy" : "Delivery address"}
        </div>

        <label>Adres</label>
        <textarea
          rows="3"
          value={form.address}
          onChange={(e) => setForm({ ...form, address: e.target.value })}
        />
        {errors.address && <div className="error">{errors.address}</div>}

        <label>Kraj</label>
        <select
          value={form.country}
          onChange={(e) => setForm({ ...form, country: e.target.value })}
        >
          <option value="PL">Polska</option>
          <option value="WORLD">Poza Polską</option>
        </select>
        {errors.country && <div className="error">{errors.country}</div>}

        {/* PAYMENT */}
        <div className="checkout-section-title" style={{ marginTop: "10px" }}>
          Metoda płatności
        </div>

        <select
          value={form.payment}
          onChange={(e) => setForm({ ...form, payment: e.target.value })}
        >
          <option value="P24">Przelewy24 / PayU (online)</option>
          <option value="BANK">Przelew tradycyjny</option>
        </select>

        {/* TOTAL */}
        <div className="checkout-section-title" style={{ marginTop: "20px" }}>
          Podsumowanie
        </div>

        <div className="checkout-total-box">
          {lang === "pl" ? "Razem:" : "Total:"} {total} zł
        </div>

        <button className="btn-primary" type="submit">
          {lang === "pl" ? "Przejdź do płatności" : "Proceed to payment"}
        </button>
      </form>
    </section>
  );
}
